import { create } from "zustand";
import Product from "../interfaces/product";

export type ProductStore = {
    selectedProduct: Product;

    setSelectedProduct: (product: Product) => void;
}

const useProductStore = create<ProductStore>((set: any) => ({
    selectedProduct: {} as Product,

    setSelectedProduct: (selectedProduct: Product) => {set(() => ({selectedProduct}))},
}));

export default useProductStore;